export const SET_USERNAME = "SET_USERNAME";
export const SET_SCHOOL = "SET_SCHOOL";
export const SET_TEACHERS = "SET_TEACHERS";
export const SET_GRADE = "SET_GRADE";
export const SET_PIN = "SET_PIN";